module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/H1Zw06/images/9781439652176.jpg?1684514921760",
      "alt": "This image is the cover for the book New London, Postcard History Series"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("New London, Postcard History Series\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Founded in 1646 and known as \"the Whaling City,\" New London has played an important role in American history since Colonial days. Its natural harbor at the mouth of the Thames River connects the city to the sea. Around the turn of the 20th century, New London flourished as the hub of southeastern Connecticut. With roots as one of the main ports for the whaling industry, the city became home to a wealthy summer resort called the Pequot Colony. Over the years, dramatic changes occurred as a result of natural disasters, such as the 1938 hurricane, and man-made changes, such as the 1960s redevelopment project. Historical postcards offer a glimpse into bustling city life during this exciting time.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Lawrence Keating, Catherine Keating, Paul Foley, Timothy F. Foley\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Father and daughter Lawrence Keating and Catherine Keating were born and reared in New London, where they still reside. They have chosen postcards primarily from their personal collection.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Arcadia Publishing\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0